import styled from 'styled-components';

export const CardContainer = styled.div`
  background-color: #e0e6eb;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  max-width: 320px;
  padding: 10px;
`;

export const Title = styled.h2`
  color: #333;
  font-weight: 700;
  margin-bottom: 20px;
  text-align: center;
`;

export const EmailInput = styled.input`
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  font-size: 1rem;
  margin-bottom: 15px;
  padding: 10px;
  width: 100%;
`;

export const TermsCheckboxContainer = styled.div`
  align-items: center;
  color: #555;
  display: flex;
  font-size: 0.875rem;
  margin-bottom: 10px;
  max-width: 320px;
  width: 100%;

  input[type='checkbox'] {
    flex-shrink: 0;
    height: 18px;
    margin-right: 8px;
    width: 18px;
  }

  label {
    flex: 1;
    line-height: 1.3;
  }

  a {
    color: #007bff;
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }
`;

export const CaptchaContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
`;

export const ConfirmationModal = styled.div`
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  align-items: center;
  background: white;
  border: 2px solid #111;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  max-width: 400px;
  padding: 2.5rem 2rem 2rem 2rem;
  width: 90%;
`;

export const CheckIconContainer = styled.div`
  align-items: center;
  background: #fff;
  border: 2px solid #111;
  border-radius: 50%;
  color: #111;
  display: flex;
  font-size: 2rem;
  height: 56px;
  justify-content: center;
  margin-bottom: 1.5rem;
  width: 56px;
`;

export const ModalTitle = styled.h3`
  color: #111;
  font-size: 1.7rem;
  font-weight: 700;
  margin: 0 0 1rem;
  text-align: center;
`;

export const ModalText = styled.p`
  color: #666;
  margin: 0 0 1.5rem;
`;

export const ModalButton = styled.button`
  background: #2c7a7b;
  border: none;
  border-radius: 4px;
  color: white;
  cursor: pointer;
  font-size: 1rem;
  padding: 0.75rem 1.5rem;
  transition: background 0.2s;

  &:hover {
    background: #206163;
  }
`;

export const SubmitButton = styled.button`
  background-color: #2c7a7b;
  border: none;
  border-radius: 4px;
  color: white;
  cursor: pointer;
  font-weight: 700;
  padding: 12px;
  width: 100%;

  &:disabled {
    background-color: #a0aec0;
    cursor: not-allowed;
  }
`;
